<template>
    <el-menu
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item></sidebar-item>
    </el-menu>
</template>

<script>
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue